import React,{useState} from "react";
import SampleApprovalForm from "./SampleApprovalForm";
import SampleApprovalList from "./SampleApprovalList";

const SampleApproval = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
   
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <SampleApprovalForm addForm={setFromIsShown} update={upData}  sId={serviceId} />
      ) : (
        <SampleApprovalList addForm={setFromIsShown} update={setUpData}  sId={setServiceId} />
      )}
    </>
  );
};

export default SampleApproval;
